module.exports = __webpack_public_path__ + "img/Colored Logo.35496571.png";